import { useEffect } from 'react';
import { useObservable } from '../utils';
import { corporateAccountQuery, corporateAccountService } from '@lib/state';

export function useMyAccounts() {
  const accounts = useObservable(corporateAccountQuery.accounts);
  const loaded = useObservable(corporateAccountQuery.loaded);

  useEffect(() => {
    if (!loaded) {
      corporateAccountService.getMyAccounts();
    }
  }, [loaded]);

  return accounts;
}
